
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f1a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f1a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9Hlf4", function(module, exports) {
function $70f89b75e05f95c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $70f89b75e05f95c9$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kWiUq", function(module, exports) {

var $hQMJY = parcelRequire("hQMJY");

var $3Bd0C = parcelRequire("3Bd0C");

var $eCGcL = parcelRequire("eCGcL");

var $gquGe = parcelRequire("gquGe");
function $f3e7e46584b7f815$var$_slicedToArray(r, e) {
    return $hQMJY(r) || $3Bd0C(r, e) || $eCGcL(r, e) || $gquGe();
}
module.exports = $f3e7e46584b7f815$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hQMJY", function(module, exports) {
function $cfed19db66348378$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $cfed19db66348378$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3Bd0C", function(module, exports) {
function $29eeeb1b4554bc5c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $29eeeb1b4554bc5c$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eCGcL", function(module, exports) {

var $k8uMw = parcelRequire("k8uMw");
function $aa555a4df2201ec5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $k8uMw(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $k8uMw(r, a) : void 0;
    }
}
module.exports = $aa555a4df2201ec5$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k8uMw", function(module, exports) {
function $ea8c6e9238b8031c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $ea8c6e9238b8031c$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gquGe", function(module, exports) {
function $bf56df7ae20c2454$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $bf56df7ae20c2454$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3cqEM", function(module, exports) {

var $U9JKo = parcelRequire("U9JKo");

var $60mHf = parcelRequire("60mHf");

var $eCGcL = parcelRequire("eCGcL");

var $cbVh4 = parcelRequire("cbVh4");
function $25472b8d0a8a2081$var$_toConsumableArray(r) {
    return $U9JKo(r) || $60mHf(r) || $eCGcL(r) || $cbVh4();
}
module.exports = $25472b8d0a8a2081$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("U9JKo", function(module, exports) {

var $k8uMw = parcelRequire("k8uMw");
function $0a8cc89d570ba202$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $k8uMw(r);
}
module.exports = $0a8cc89d570ba202$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("60mHf", function(module, exports) {
function $45f4593cfeda2a57$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $45f4593cfeda2a57$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cbVh4", function(module, exports) {
function $8e02f0a04e7667b1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $8e02f0a04e7667b1$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kQtiq", function(module, exports) {
function $f2cf639cbd0eaae6$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $f2cf639cbd0eaae6$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $f2cf639cbd0eaae6$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $f2cf639cbd0eaae6$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $f2cf639cbd0eaae6$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

'use strict';

var $9Hlf4 = parcelRequire("9Hlf4");
var $f6e33684cc330641$require$_interopRequireDefault = $9Hlf4.default;

var $f6e33684cc330641$var$_slicedToArray2 = $f6e33684cc330641$require$_interopRequireDefault((parcelRequire("kWiUq")));

var $f6e33684cc330641$var$_toConsumableArray2 = $f6e33684cc330641$require$_interopRequireDefault((parcelRequire("3cqEM")));

var $f6e33684cc330641$var$_asyncToGenerator2 = $f6e33684cc330641$require$_interopRequireDefault((parcelRequire("kQtiq")));
(function() {
    var u = 'fs-attributes';
    var C = 'cmsattribute';
    var a = 'inputactive';
    var S = 'support';
    var g = /*#__PURE__*/ function() {
        var _ref = (0, $f6e33684cc330641$var$_asyncToGenerator2.default)(function*() {
            var s;
            var e = [];
            for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++)t[_key] = arguments[_key];
            for (var n of t){
                var o = yield (s = window.fsAttributes[n]) == null ? void 0 : s.loading;
                e.push(o);
            }
            return e;
        });
        return function g() {
            return _ref.apply(this, arguments);
        };
    }();
    var m = function m() {};
    function x(t, e, s, n) {
        return t ? (t.addEventListener(e, s, n), function() {
            return t.removeEventListener(e, s, n);
        }) : m;
    }
    var _ = {
        formBlock: 'w-form',
        checkboxField: 'w-checkbox',
        checkboxInput: 'w-checkbox-input',
        radioField: 'w-radio',
        radioInput: 'w-radio-input',
        checkboxOrRadioLabel: 'w-form-label',
        checkboxOrRadioFocus: 'w--redirected-focus',
        checkboxOrRadioChecked: 'w--redirected-checked',
        successMessage: 'w-form-done',
        errorMessage: 'w-form-fail'
    };
    var v = function v(t) {
        return t instanceof HTMLInputElement;
    };
    var d = function d(t) {
        return typeof t == 'string';
    };
    function U(t, e, s) {
        var o;
        var n = window.fsAttributes[t];
        return n.destroy = s || m, (o = n.resolve) == null || o.call(n, e), e;
    }
    var L = function L(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1';
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iife';
        var o = `${t}${s === 'esm' ? '.esm' : ''}.js`;
        return `https://cdn.jsdelivr.net/npm/@finsweet/attributes-${t}@${e}/${o}`;
    };
    var F = `${u}-${S}`, B = /*#__PURE__*/ function() {
        var _ref2 = (0, $f6e33684cc330641$var$_asyncToGenerator2.default)(function*() {
            var o;
            var _window = window, t = _window.fsAttributes, e = _window.location, _URL = new URL(e.href), s = _URL.host, n = _URL.searchParams;
            return !s.includes('webflow.io') || !n.has(F) ? !1 : (o = t.import) == null ? void 0 : o.call(t, S, '1');
        });
        return function B() {
            return _ref2.apply(this, arguments);
        };
    }();
    var E = function E(t) {
        var e = function e(o, i, r) {
            var c = t[o], p = c.key, b = c.values, l;
            if (!i) return `[${p}]`;
            var f = b == null ? void 0 : b[i];
            d(f) ? l = f : l = f(r && 'instanceIndex' in r ? r.instanceIndex : void 0);
            var A = r && 'caseInsensitive' in r && r.caseInsensitive ? 'i' : '';
            if (!(r != null && r.operator)) return `[${p}="${l}"${A}]`;
            switch(r.operator){
                case 'prefixed':
                    return `[${p}^="${l}"${A}]`;
                case 'suffixed':
                    return `[${p}$="${l}"${A}]`;
                case 'contains':
                    return `[${p}*="${l}"${A}]`;
            }
        };
        function s(o, i) {
            var r = e('element', o, i), c = (i == null ? void 0 : i.scope) || document;
            return i != null && i.all ? (0, $f6e33684cc330641$var$_toConsumableArray2.default)(c.querySelectorAll(r)) : c.querySelector(r);
        }
        return [
            e,
            s,
            function(o, i) {
                var r = t[i];
                return r ? o.getAttribute(r.key) : null;
            }
        ];
    };
    var T = {
        preventLoad: {
            key: `${u}-preventload`
        },
        debugMode: {
            key: `${u}-debug`
        },
        src: {
            key: 'src',
            values: {
                finsweet: '@finsweet/attributes'
            }
        },
        dev: {
            key: `${u}-dev`
        }
    }, _E = E(T), _E2 = (0, $f6e33684cc330641$var$_slicedToArray2.default)(_E, 2), I = _E2[0], bt = _E2[1];
    var h = function h(t) {
        var _document = document, e = _document.currentScript, s = {};
        if (!e) return {
            attributes: s,
            preventsLoad: !1
        };
        var o = {
            preventsLoad: d(e.getAttribute(T.preventLoad.key)),
            attributes: s
        };
        for(var i in t){
            var r = e.getAttribute(t[i]);
            o.attributes[i] = r;
        }
        return o;
    };
    var M = function M(_ref3) {
        var t = _ref3.scriptAttributes, e = _ref3.attributeKey, s = _ref3.version, n = _ref3.init;
        var c;
        H(), (c = window.fsAttributes)[e] || (c[e] = {});
        var _h = h(t), o = _h.preventsLoad, i = _h.attributes, r = window.fsAttributes[e];
        r.version = s, r.init = n, o || (window.Webflow || (window.Webflow = []), window.Webflow.push(function() {
            return n(i);
        }));
    }, H = function H() {
        var t = G();
        if (window.fsAttributes && !Array.isArray(window.fsAttributes)) {
            R(window.fsAttributes, t);
            return;
        }
        var e = j(t);
        R(e, t), q(e), window.fsAttributes = e, window.FsAttributes = window.fsAttributes, B();
    }, j = function j(t) {
        var e = {
            cms: {},
            push: function push() {
                var n, o;
                for(var _len2 = arguments.length, s = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)s[_key2] = arguments[_key2];
                for (var _ref4 of s){
                    var _ref5 = (0, $f6e33684cc330641$var$_slicedToArray2.default)(_ref4, 2);
                    var i = _ref5[0];
                    var r = _ref5[1];
                    (o = (n = this[i]) == null ? void 0 : n.loading) == null || o.then(r);
                }
            },
            import: function() {
                var _import2 = (0, $f6e33684cc330641$var$_asyncToGenerator2.default)(function*(s, n) {
                    var o = e[s];
                    return o || new Promise(function(i) {
                        var r = document.createElement('script');
                        r.src = L(s, n), r.async = !0, r.onload = function() {
                            var _R = R(e, [
                                s
                            ]), _R2 = (0, $f6e33684cc330641$var$_slicedToArray2.default)(_R, 1), c = _R2[0];
                            i(c);
                        }, document.head.append(r);
                    });
                });
                function _import(_x, _x2) {
                    return _import2.apply(this, arguments);
                }
                return _import;
            }(),
            destroy: function destroy() {
                var s, n;
                for (var o of t)(n = (s = window.fsAttributes[o]) == null ? void 0 : s.destroy) == null || n.call(s);
            }
        };
        return e;
    }, G = function G() {
        var t = I('src', 'finsweet', {
            operator: 'contains'
        }), e = I('dev');
        return (0, $f6e33684cc330641$var$_toConsumableArray2.default)(document.querySelectorAll(`script${t}, script${e}`)).reduce(function(o, i) {
            var c;
            var r = i.getAttribute(T.dev.key) || ((c = i.src.match(/[\w-. ]+(?=(\.js)$)/)) == null ? void 0 : c[0]);
            return r && !o.includes(r) && o.push(r), o;
        }, []);
    }, R = function R(t, e) {
        return e.map(function(n) {
            var o = t[n];
            return o || (t[n] = {}, o = t[n], o.loading = new Promise(function(i) {
                o.resolve = function(r) {
                    i(r), delete o.resolve;
                };
            }), o);
        });
    }, q = function q(t) {
        var e = Array.isArray(window.fsAttributes) ? window.fsAttributes : [];
        t.push.apply(t, (0, $f6e33684cc330641$var$_toConsumableArray2.default)(e));
    };
    var N = '1.0.0';
    var O = `fs-${a}`, Y = 'class', W = {
        value: 'value'
    }, z = {
        element: {
            key: `${O}-element`,
            values: {}
        },
        class: {
            key: `${O}-${Y}`,
            values: W
        }
    }, _E3 = E(z), _E4 = (0, $f6e33684cc330641$var$_slicedToArray2.default)(_E3, 3), P = _E4[0], Ut = _E4[1], V = _E4[2], w = `is-active-${a}`;
    var y = function y(t) {
        var e = t.type === 'checkbox', s = t.closest(`.${_.checkboxField}`);
        if (e && s) {
            var i = k(t);
            $(s, i, t.checked);
            return;
        }
        if (!(t.type === 'radio')) return;
        var o = document.querySelectorAll(`input[type="radio"][name="${t.name}"]`);
        for (var _i of o){
            var r = _i.closest(`.${_.radioField}`);
            if (!r) continue;
            var c = k(_i);
            $(r, c, _i.checked);
        }
    }, k = function k(t) {
        var e = t.closest(P('class'));
        return e ? V(e, 'class') || w : w;
    }, $ = function $(t, e) {
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        return t.classList[s ? 'add' : 'remove'](e);
    };
    var K = function K() {
        return document.querySelectorAll('input').forEach(y), x(window, 'change', function(s) {
            var n = s.target;
            !v(n) || y(n);
        });
    };
    var D = /*#__PURE__*/ function() {
        var _ref6 = (0, $f6e33684cc330641$var$_asyncToGenerator2.default)(function*() {
            yield g(C);
            var t = K();
            return U(a, void 0, t);
        });
        return function D() {
            return _ref6.apply(this, arguments);
        };
    }();
    M({
        init: D,
        version: N,
        attributeKey: a
    });
})();


//# sourceMappingURL=self-employed-tax-calculator.ff09c6bb.js.map
